<template>
  <div class="view-cassino">
    <!-- Sidebar esquerdo ocupando 50% da tela -->
    <div class="left-sidebar">
      <div class="sidebar-top"></div>
      
      <div class="main-content-container">
        <!-- Imagem principal com conteúdo interno e seta esquerda -->
        <div class="image-container">
          <div class="navigation-arrow left-arrow" @click="navigateLeft">
            <span>‹</span>
          </div>
          <div class="main-image"></div>
          
          <!-- Conteúdo dentro da imagem principal -->
          <div class="internal-content">
            <div class="game-button multiplayer-btn" @click="abrirEmNovaAba('multi')"></div>
            <div class="game-button singleplayer-btn" @click="abrirEmNovaAba('solo')"></div>
            <div class="sidebar-footer"></div>
          </div>
        </div>
        
        <!-- Imagem secundária com seta direita -->
        <div class="image-container">
          <div class="secondary-image"></div>
          <div class="navigation-arrow right-arrow" @click="navigateRight">
            <span>›</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Espaço vazio do lado direito (50%) -->
    <div class="right-space"></div>
  </div>
</template>

<script setup>
function abrirEmNovaAba(modo) {
  const rotas = {
    solo: '/BlackjackSolo',
    multi: '/BlackjackMultiplayer',
    checkers: '/CheckersMultiplayer',
  };
  const path = rotas[modo] || '/';
  window.open(`${window.location.origin}${path}`, '_blank');
}

function navigateLeft() {
  // Lógica para navegar para o jogo anterior
  console.log("Navegar para esquerda");
}

function navigateRight() {
  // Lógica para navegar para o próximo jogo
  console.log("Navegar para direita");
}
</script>

<style scoped>
.view-cassino {
  display: flex;
  min-height: 100vh;
  background-image: url('@/assets/background/cassino/cassinoz.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

.left-sidebar {
  width: 50%;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  box-sizing: border-box;
}

.right-space {
  width: 50%;
}

/* Topo da sidebar reduzido para 70% */
.sidebar-top {
  width: 70%;
  height: 150px;
  margin: 0 auto 2rem auto;
  background-image: url('@/assets/background/cassino/cassinoz9.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

/* Container principal do conteúdo */
.main-content-container {
  display: flex;
  width: 100%;
  height: 65vh;
  gap: 20px;
  position: relative;
}

/* Container para cada imagem */
.image-container {
  position: relative;
  width: 60%;
  height: 100%;
}

/* Imagem principal */
.main-image {
  width: 100%;
  height: 100%;
  background-image: url('@/assets/background/cassino/cassinoz2.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

/* Imagem secundária */
.secondary-image {
  width: 100%;
  height: 100%;
  background-image: url('@/assets/background/cassino/cassinoz3.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

/* Conteúdo dentro da imagem principal */
.internal-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15% 10%;
  box-sizing: border-box;
}

/* Setas de navegação */
.navigation-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 80px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s ease;
  color: white;
  font-size: 2rem;
  font-weight: bold;
}

.navigation-arrow:hover {
  background-color: rgba(0, 0, 0, 0.8);
  transform: translateY(-50%) scale(1.1);
}

.left-arrow {
  left: -50px;
}

.right-arrow {
  right: -50px;
}

/* Botões dos jogos */
.game-button {
  width: 80%;
  height: 120px;
  margin: 1rem 0;
  cursor: pointer;
  transition: all 0.3s ease;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.game-button:hover {
  transform: scale(1.05);
  filter: brightness(1.1);
}

.multiplayer-btn {
  background-image: url('@/assets/background/cassino/cassinoz7.png');
}

.singleplayer-btn {
  background-image: url('@/assets/background/cassino/cassinoz8.png');
}

/* Rodapé */
.sidebar-footer {
  width: 100%;
  height: 80px;
  margin-top: auto;
  background-image: url('@/assets/background/cassino/cassinoz6.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

/* Responsividade */
@media (max-width: 1200px) {
  .left-sidebar {
    width: 60%;
  }
  .right-space {
    width: 40%;
  }
  
  .navigation-arrow {
    width: 30px;
    height: 60px;
    font-size: 1.5rem;
  }
  
  .left-arrow {
    left: -40px;
  }
  
  .right-arrow {
    right: -40px;
  }
}

@media (max-width: 768px) {
  .view-cassino {
    flex-direction: column;
  }
  .left-sidebar, .right-space {
    width: 100%;
  }
  .main-content-container {
    flex-direction: column;
    height: auto;
    gap: 40px;
  }
  .image-container {
    width: 80%;
    height: 50vh;
    margin: 0 auto;
  }
  .navigation-arrow {
    width: 30px;
    height: 60px;
  }
  .left-arrow {
    left: -35px;
  }
  .right-arrow {
    right: -35px;
  }
  .sidebar-top {
    width: 80%;
    height: 120px;
  }
}
</style>